/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Pages_Back_To_HomeInputs */

const en_common_pages_back_to_home = /** @type {(inputs: Common_Pages_Back_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to home`)
};

const zh_common_pages_back_to_home = /** @type {(inputs: Common_Pages_Back_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回首页`)
};

/**
* | output |
* | --- |
* | "Back to home" |
*
* @param {Common_Pages_Back_To_HomeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_pages_back_to_home = /** @type {((inputs?: Common_Pages_Back_To_HomeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Pages_Back_To_HomeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_pages_back_to_home(inputs)
	return zh_common_pages_back_to_home(inputs)
});
export { common_pages_back_to_home as "common.pages.back_to_home" }